import { render } from "./OtaServerUrlList.vue?vue&type=template&id=222bce5f&scoped=true"
import script from "./OtaServerUrlList.vue?vue&type=script&lang=js"
export * from "./OtaServerUrlList.vue?vue&type=script&lang=js"

import "./OtaServerUrlList.vue?vue&type=style&index=0&id=222bce5f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222bce5f"]])

export default __exports__